import { cn } from "@/lib/utils";

/**
 * Drive feature mark — a flywheel "engine" (hub + three curved blades) inside a
 * recurring-cycle arrow. The custom glyph for the Drive product surface: the
 * blades read as stored momentum that keeps spinning, the circular arrow as the
 * recurring loop (not a static car wheel).
 *
 * Lucide-compatible so it's a drop-in for a lucide icon: 24×24 viewBox,
 * ``stroke="currentColor"``, 2px round caps — sizes via Tailwind ``h-*``/``w-*``
 * and follows the surrounding text color (chip, dark mode, muted, …).
 *
 * Usage:
 *   <DriveIcon className="h-4 w-4" />
 */
export function DriveIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={cn(className)}
      {...props}
    >
      {/* recurring-cycle arrow — the modern rotate-cw arc that draws a line into
          its arrowhead vertex so the head connects to the arc instead of floating. */}
      <path d="M21 12a9 9 0 1 1-9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
      <path d="M21 4.2v3.8h-3.8" />
      {/* flywheel engine: hub + three curved blades (swirl = motion) */}
      <circle cx="12" cy="12" r="2.5" />
      <path d="M12 9.5Q14.2 7 12 4.5" />
      <path d="M14.165 13.25Q15.23 16.405 18.495 15.75" />
      <path d="M9.835 13.25Q6.57 12.595 5.505 15.75" />
    </svg>
  );
}
